export default __webpack_public_path__ + "static/home_intro-720-2494a25efed0313ed37c65fa93323fff.webm";